module.exports = __webpack_public_path__ + "assets/26df866e78eb6917d5d8d2a62ffe4194.mp3";